
import { SubDomain } from "../SubDomain.js";
import Company from "./Company.js";
import CompanyMap from "./CompanyMap.js";
import CompanyStats from "./CompanyStats.js";
import ContentUtils from '@/utils/ContentUtils.js';

export default class CompanysDomain extends SubDomain {
  
  constructor(domain, storeMap) {
    super(domain, Company.MODEL_NAME);
    this.storage = storeMap.companys_found;
    this.stats = storeMap.company_stats;
  }

  list() {
    return this.storage.list;
  }
  
  findAll() {
    var objects = this.list();
    var companys = new CompanyMap(this.domain);
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      var company = new Company(this.domain, item);
      companys.add(company);
    }

    return companys;
  }
  
  findById(objId) {
    var objects = this.list();
    const newId = ContentUtils.baseDecode(objId);
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) === newId) {
        return new Company(this.domain, item);
      }
    }

    return new Company(this.domain).withId(objId);
  }
  
  findDivisionsForCompany(company) {
    var objects = this.list();
    let map = new CompanyMap(this.domain);
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      var companyItem = new Company(this.domain, item);

      if (companyItem.parent().idEquals(company)) {
        map.add(companyItem);
      }
    }

    return map;
  }

  findStatsById(objId) {
    var item = null;
    for (var i = 0; i < this.stats.list.length; i++) {
      var listItem = this.stats.list[i];
      if (listItem.Company['@rid'] === objId) {
        item = listItem;
        break;
      }
    }
    return new CompanyStats(this.domain, item);
  }
}